import * as apiUtils from "@/utils/apiUtils"

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {},
  // -----------------------------------------------------------------
  getters: {},
  // -----------------------------------------------------------------
  mutations: {},
  // -----------------------------------------------------------------
  actions: {
    getTransactions: (context, query) => {
      var bid = context.rootGetters["bizes/bid"]()
      var queryString = Object.keys(query)
        .map(key => key + "=" + query[key])
        .join("&")
      var path = "/bizes/" + bid + "/accounting/transactions"
      if (queryString != "") {
        path = path + "?" + queryString
      }
      return apiUtils.get(path)
    },
    getTransaction: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/transactions/" + id
      return apiUtils.get(path)
    },
    createTransaction: (context, transaction) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/transactions"
      return apiUtils.post(path, transaction)
    },
    updateTransaction: (context, transaction) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/transactions/" + transaction.id
      return apiUtils.patch(path, transaction)
    },
    deleteTransaction: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/transactions/" + id
      return apiUtils.delete(path)
    },
    duplicateTransaction: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/transactions/" + id + "/duplicate"
      return apiUtils.post(path)
    },
    sendReceipt: (context, { id, from, cc }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/transactions/" + id + "/send-receipt"
      return apiUtils.post(path)
    },
    sendReceiptByEmail: (context, { id, emails, from, cc }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/transactions/" + id + "/send-receipt-by-email"
      return apiUtils.post(path, {
        emails,
        from,
        cc
      })
    },
    getInvoiceTransactionRecords: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/transaction-payment-records?resourceId=" + id + "&resourceType=Invoice"
      return apiUtils.get(path)
    },
    getBillTransactionRecords: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/transaction-payment-records?resourceId=" + id + "&resourceType=Bill"
      return apiUtils.get(path)
    },
    exportTransactions: context => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/accounting/export-transactions"
      return apiUtils.post(path)
    }
  }
}
